export class SessionKey {
    // Global Keys
    static SESSION = 'Session'
    static REDIRECT_PAGE = 'RedirectPage'

    // JWT Related
    static IDENTITY_TOKEN = 'IdentityToken'

    // Secure Config Keys
    static PARSE_JS_KEY = 'ParseJsKey'
    static PARSE_API_KEY = 'ParseApiKey'
    static SES_ROLE_EXT_ID = 'SesRoleExtId'
    static GOOGLE_MAPS_API_KEY = 'GoogleMapsApiKey'
    static AZURE_SEARCH_API_KEY = 'AzureSearchApiKey'
    static AZURE_SEARCH_ADMIN_KEY = 'AzureSearchAdminKey'
    static PRIVATE_ROUTE_AUTH_CODE = 'PrivateRouteAuthorizationCode'
}
